import { Box, Typography, Button } from '@mui/material';

interface ProgramTypeCardProps {
  title: string;
  description: string;
  onSelect: () => void;
}

export function ProgramTypeCard({ title, description, onSelect }: ProgramTypeCardProps) {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 260, md: 280 },
        height: 300,
        p: 2,
        backgroundColor: '#151515',
        borderRadius: '6px',
        border: '1px solid #444',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2.5,
        fontFamily: 'Inter, sans-serif'
      }}
    >
      <Typography fontSize={18} fontWeight={700} textAlign="center" color="#FDFDFD" lineHeight="30px">
        {title}
      </Typography>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          px: 1
        }}
      >
        <Typography fontSize={12} fontWeight={400} textAlign="center" color="#B6B6B6">
          {description}
        </Typography>
      </Box>

      <Button
        onClick={onSelect}
        sx={{
          height: 42,
          width: '100%',
          background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
          borderRadius: '6px',
          color: '#FDFDFD',
          fontSize: 13,
          fontWeight: 600,
          textTransform: 'none',
          '&:hover': { opacity: 0.9 }
        }}
      >
        Select
      </Button>
    </Box>
  );
}
